<template>
  <v-layout column>
    <v-toolbar flat>
      <v-toolbar-title>
        Conversation history
      </v-toolbar-title>
      <v-spacer />
      <v-icon @click="reloadConversation()">refresh</v-icon>
    </v-toolbar>
    <v-layout v-if="!disableForm" wrap justify-start>
      <v-flex sm12 md8>
        <v-textarea block v-model="bidText"
                    :rows="2"
                    label="Type something...">
        </v-textarea>
      </v-flex>
      <v-flex sm12 md2 class="px-1">
        <v-btn block class="mr-1 px-0"
               :loading="loadingBtn"
               :disabled="loadingBtn"
               @click="sendBidMessage">
          Send
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="timeline-section"
         :class="{'text-md-center text-lg-center text-sm-center pt-4': loadingData}">
      <timeline v-if="bidTimeline && !loadingData"
                :timeline-object="bidTimeline"></timeline>
      <v-progress-circular v-if="loadingData"
                           indeterminate color="primary">
      </v-progress-circular>
    </div>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import API from '@/api';
import Timeline from '@/components/timeline/Timeline';

export default {
  name: 'BidConversation',
  props: {
    bidId: {
      type: String,
      required: true,
    },
    disableForm: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    Timeline,
  },
  data: () => ({
    loadingData: false,
    loadingBtn: false,
    bidTimeline: null,
    bidText: null,
  }),
  computed: {
    _() {
      return _;
    },
  },
  watch: {
    bidId(newId) {
      this.loadConversation(newId);
    },
  },
  methods: {
    reloadConversation() {
      this.loadConversation(this.bidId);
    },
    loadConversation(bidId) {
      this.loadingData = true;
      API.bid.getConversation({ bidId }).then((timelineResponse) => {
        this.bidTimeline = timelineResponse.data;
        this.loadingData = false;
      });
    },
    async sendBidMessage() {
      try {
        this.loadingBtn = true;
        await API.bid.updateBidTimeline({
          bidId: this.bidId,
          messageRequest: {
            message: this.bidText,
            sent: new Date().toISOString(),
          },
        });
        this.loadConversation(this.bidId);
        this.bidText = '';
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'An error occurred, please try again later',
        });
      } finally {
        this.loadingBtn = false;
      }
    },
  },
  created() {
    this.loadConversation(this.bidId);
  },
};
</script>

<style scoped>
  .timeline-section {
    height: 350px;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/BidConversation.vue